import React, { Component } from "react";
import { Switch, Route, withRouter } from "react-router-dom";
import { Link } from "react-router-dom";
import Team from "../projectmgmt/settings/team/Team";
import $ from "jquery";
import StsApiKeys from "./StsApiKeys";

class StsSettings extends Component {
  componentDidMount() {
    (function () {
      var currentPath = window.location.href;

      var path = window.origin + "/platform/cloud-sts/";
      var path1 = window.origin + "/platform/cloud-sts";
      if (currentPath === path || currentPath === path1) {
        $("#api-keys").addClass("active");
      } else if (
        currentPath.includes("/cloud-sts/team") ||
        currentPath.includes("/projectmgmt/team/")
      ) {
        $("#team-tab").addClass("active");
      } else {
        $("#" + localStorage.getItem("last-project-settings-tab")).addClass(
          "active"
        );
      }
      $("#api-keys,#team-tab").on("click", function () {
        $("#api-keys,#team-tab").removeClass("active");
        localStorage.setItem("last-project-settings-tab", $(this)[0].id);

        $(this).addClass("active");
      });
    })();
  }
  render() {
    return (
      <div id="tabPage">
        <div className="content" style={{ backgroundColor: "#F9F9FB" }}>
          <link
            rel="shortcut icon"
            type="image/png"
            href="assets/images/bot.ico"
          />
          <title> Dheeyantra | Clusters Details</title>
          {/* Font Awesome Icons */}
          <link
            rel="stylesheet"
            href="plugins/font-awesome/css/font-awesome.min.css"
          />
          {/* IonIcons */}
          <link
            rel="stylesheet"
            href="//code.ionicframework.com/ionicons/2.0.1/css/ionicons.min.css"
          />
          <link rel="stylesheet" href="assets/fonts/flat-icon/flaticon.css" />
          {/* Theme style */}
          <link rel="stylesheet" href="assets/css/adminlte.css" />
          <link
            href="https://cdn.jsdelivr.net/npm/gijgo@1.9.6/css/gijgo.min.css"
            rel="stylesheet"
          />
          <link rel="stylesheet" href="assets/css/custom-style.css" />
          <link rel="stylesheet" href="assets/css/styles.css" />
          <div className="content-header">
            <div className="container-fluid">
              <div className="row">
                <div className="col-sm-5">
                  <h1 className="m-0 page-title">Paribhasha Settings</h1>
                  {/* <h6 className="taglineTxt">Agent Configurations</h6> */}
                </div>
              </div>
            </div>
          </div>
          <div className="container-fluid">
            {/* Nav tabs */}
            <div className="border-bottom"></div>
            <div className="tab-class">
              <ul className="nav nav-tabs border-bottom navCluster">
                <Link
                  className="nav-item"
                  to="/cloud-sts"
                  style={{ textDecoration: "none" }}
                >
                  <li className="nav-link" id="api-keys">
                    API Keys
                  </li>
                </Link>
                <Link
                  className="nav-item"
                  to="/cloud-sts/team"
                  style={{ textDecoration: "none" }}
                >
                  <li className="nav-link" id="team-tab">
                    Team
                  </li>
                </Link>
              </ul>
            </div>
          </div>
        </div>
        <Switch>
          <Route path="/cloud-sts/team" component={Team}></Route>
          <Route path="/cloud-sts" component={StsApiKeys}></Route>
        </Switch>
      </div>
    );
  }
}
export default StsSettings;



// WEBPACK FOOTER //
// ./src/stsUi/ParibhasaSettings.js